import AppBackgroundColor from '@components/app-background-color/AppBackgroundColor';
import { ContentBlock } from '@layouts/ContentBlocks';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeSeoData } from 'config/next-seo.config';
import Head from 'next/head';
import { NextSeo } from 'next-seo';
import React from 'react';

import JobCard from '../../../components/cards/JobCard';
import useStyles from '../careers.style';

const title = 'Staging Stylist - Careers at Guest House';
const description = 'Guest House is a staging and retail company looking for talented future designers who are eager for hands-on experience. We pride ourselves on working with individuals who are always ready to dive-in, self-motivated and have a passion for design by helping homes come to life.';
const jobTitle = 'Staging Stylist';
const location = 'San Diego - Part Time';
const applyLink = 'mailto:careers@guesthouseshop.com?subject=I\'m interested in becoming a Staging Stylist at Guest House in San Diego';
const responsibilites = [
  'Onsite stylist handling the installation of our staging projects, including: styling vignettes; hanging art; and making beds',
  'Selecting and packing decor and finishing touches from our 8000 sq ft warehouse to compliment the overall design concept of each project',
  'Working closely with our Lead Designer throughout the planning process to confirm mood boards, clarify install notes and successfully execute beautiful designs',
  'Warehouse organizational support and additional design opportunities',
];
const jobDetails = [
  'This is an hourly position with flexible timeframes during typical business hours.',
  'This role is meant to supplement school or other work opportunities and requires between 8-20 hours of availability each week, depending on the schedule.',
  'All of our homes are professionally photographed and as the stylist, you\'ll receive access to high-end photography of all your work for your portfolio.',
  'This job is a great opportunity for young designers to get hands-on experience working with today\'s top furniture brands in beautiful homes all across San Diego.',
];

function CareersStagingStylist() {
  const { classes, theme } = useStyles();


  return (
    <>
      <AppBackgroundColor backgroundColor="#f6f1f0" />
      <Head>
        <title>
          {title}
        </title>
      </Head>

      <NextSeo {...makeSeoData({ pageTitle: title, metaTitle: title, metaDescription: description })} />

      <ContentBlock
        maxWidth={1365}
        margin={[8, 0]}
      >
        <Grid
          item
          md={8}
          style={{ margin: 'auto' }}
        >
          <JobCard
            jobTitle={jobTitle}
            location={location}
            applyLink={applyLink}
            style={{ textAlign: 'left' }}
          >
            <Typography
              component="h2"
              variant="h4Alt"
              className={classes.jobDescriptionHeader}
            >
              The Role
            </Typography>

            <Typography className={classes.jobDescriptionText}>
              Guest House is a staging and retail company looking for talented future designers who are eager for hands-on experience. We pride ourselves on working with individuals who are always ready to dive-in, self-motivated and have a passion for design by helping homes come to life.
            </Typography>

            <Typography
              component="h3"
              variant="h5Alt"
              className={classes.jobDescriptionHeader}
            >
              We are currently looking to hire a team of staging stylists that will work alongside our lead interior designer in our homes.  Responsibilities include the following:
            </Typography>

            {responsibilites.map((responsibility, i) => (
              <Typography
                key={i}
                component="ul"
              >
                <Typography
                  component="li"
                  className={classes.jobDescriptionText}
                >
                  {responsibility}
                </Typography>
              </Typography>
            ))
            }

            <Typography
              className={classes.jobDescriptionText}
              style={{ margin: theme.spacing(2, 0), fontWeight: 'bold', }}
            >
              Some more details:
            </Typography>

            {jobDetails.map((jobDetail, i) => (
              <Typography
                key={i}
                component="ul"
              >
                <Typography
                  component="li"
                  className={classes.jobDescriptionText}
                >
                  {jobDetail}
                </Typography>
              </Typography>
            ))}
            
            <Typography
              className={classes.jobDescriptionText}
              style={{ margin: theme.spacing(2, 0), }}
            >
              Compensation for this role is 
              {' '}
              <b>
                $18/hour
              </b>
              .
            </Typography>
          </JobCard>
        </Grid>
      </ContentBlock>
    </>
  );
}

export default CareersStagingStylist;
